import React from 'react'
import { Icon } from 'antd'
import style from './Utils.less'

export const LogoSmall = (props) => {
  return (
    <a>
      <div className={style.logoSmall}>
        <span>
          <img src={'/img/nsai-logo-black.svg'} height={30} alt='Logo' />
        </span>
        <span style={{ display: 'block', marginLeft: '20px' }}>
        Nodo Sensorial
          <br />
        Autonomo inteligente
        </span>
      </div>
    </a>
  )
}

export const LogoMiddle = (props) => {
  return (
    <a>
      <div className={style.logoMiddle}>
        <img src={'/img/nsai-logo-white.svg'} alt='Logo' style={{
          marginLeft: props.collapsed ? '0px' : '15px',
          maxWidth: props.collapsed ? '60px' : '70px'
        }} />
        <span style={{ visibility: props.collapsed ? 'hidden' : 'visible' }}>
          Nodo Sensorial
          <br />
          Autonomo inteligente
        </span>
      </div>
    </a>
  )
}

export const Cinnova = (props) => {
  return (
    <a href='http://www.innovatecnologia.com/' className={style.cInnova}>&copy; Innova</a>
  )
}

export const IconCustom = (props) => {
  return (
    <Icon className={style.iconCustom}><span className={props.type} /></Icon>
  )
}

export const LoadingChart = (props) => (
  <div className={style.loading} style={{ lineHeight: props.height ? props.height + 'px' : '400px' }}>
    <Icon type='loading' />
  </div>
)

const inlineIndicators = ([value, prefix, color], i) => (
  <span style={{ color: color || '#000' }} key={i}>
    {`${i > 0 ? ' - ' : ' '} ${value} ${prefix}`}
  </span>
)

export const Header = (props) => (
  <div className={style.header}>
    <div>
      {props.title}
    </div>
    {props.connect
      ? props.showline && props.indicators
        ? <div className='indicators'>
          {props.indicators.map(inlineIndicators)}
        </div>
        : null
      : <div className='status'>  DISCONNECT </div>
    }
  </div>
)



// WEBPACK FOOTER //
// ./src/utils/Utils.js